import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import logo from "./../../assets/images/logo.png";
import ButtonAddPicture from "../atoms/ButtonAddPicture";
import { connect } from "react-redux";
import { firestoreConnect } from "react-redux-firebase";
import { compose } from "redux";
import { completeProfile } from "../../redux/store/actions/authActions";
import Dropzone from "react-dropzone";

class AccesForm extends Component {

  state = {
    firstName: "",
    lastName: "",
    empresa: "",
    cargo: "",
    departamento: "",
    tel1: "",
    tel2: "",
    email: "",
    emailSeguridad: ""
  };

  componentDidMount() {

  }

  componentWillMount(nextProps) {
    
  }

  handleChange = e => {
    this.setState({
      [e.target.id]: e.target.value
    });
  };
  handleSubmit = e => {
    e.preventDefault();
    this.props.completeProfile(this.state);
    // console.log(this.state)
  };
  clearAuthError = e => {
    this.props.authError = null;
  };
  
  render() {
    const { authError, auth, profile } = this.props;

    // console.log(profile.eMail);

    if (!auth.uid) return <Redirect to="/entrar" />;
    else if (auth.uid && profile.cargo) return <Redirect to="/" />;
    else if (auth.uid && !profile.cargo)
      return (
        <div className="pt center-align p-x-15">
          <img src={logo} alt="" style={{ width: "180px" }} />
          <h5 style={{ marginTop: "2rem" }}>
            Por favor, para continuar confirme o rellene sus datos
          </h5>
          <br />
          <br />
          <ButtonAddPicture className="blue">
            <div>
              <Dropzone />
            </div>
          </ButtonAddPicture>
          <br />
          <br />
          <form onSubmit={this.handleSubmit} className="white">
            <div className="row">
              <div className="col s4">
                <div className="input-field">
                  <i className="material-icons prefix indigo-text text-accent-4">
                    account_circle
                  </i>
                  <label htmlFor="firstName">Nombre *</label>
                  <input
                    type="text"
                    required
                    id="firstName"
                    onChange={this.handleChange}
                  />
                </div>
                <div className="input-field">
                  <i className="material-icons prefix indigo-text text-accent-4">
                    account_circle
                  </i>
                  <label htmlFor="lastName">Apellidos *</label>
                  <input
                    type="text"
                    required
                    id="lastName"
                    onChange={this.handleChange}
                  />
                </div>
                <div className="input-field">
                  <i className="material-icons prefix indigo-text text-accent-4">
                    account_circle
                  </i>
                  <label htmlFor="empresa">Empresa *</label>
                  <input
                    type="text"
                    required
                    id="empresa"
                    onChange={this.handleChange}
                  />
                </div>
                <div className="input-field">
                  <i className="material-icons prefix indigo-text text-accent-4">
                    account_circle
                  </i>
                  <label htmlFor="cargo">Cargo</label>
                  <input
                    type="text"
                    required
                    id="cargo"
                    onChange={this.handleChange}
                  />
                </div>
                <div className="input-field">
                  <i className="material-icons prefix indigo-text text-accent-4">
                    account_circle
                  </i>
                  <label htmlFor="departamento">Departamento</label>
                  <input
                    type="text"
                    required
                    id="departamento"
                    onChange={this.handleChange}
                  />
                </div>
              </div>

              <div className="col s4">
                <div className="input-field">
                  <i className="material-icons prefix indigo-text text-accent-4">
                    account_circle
                  </i>
                  <label htmlFor="tel1">Teléfono 1</label>
                  <input
                    type="tel"
                    required
                    id="tel1"
                    onChange={this.handleChange}
                  />
                </div>
                <div className="input-field">
                  <i className="material-icons prefix indigo-text text-accent-4">
                    account_circle
                  </i>
                  <label htmlFor="tel2">Teléfono 2</label>
                  <input
                    type="tel"
                    required
                    id="tel2"
                    onChange={this.handleChange}
                  />
                </div>
                <div className="input-field">
                  <i className="material-icons prefix indigo-text text-accent-4">
                    alternate_email
                  </i>
                  <label htmlFor="email">Email *</label>
                  <input
                    type="email"
                    id="email"
                    readOnly
                    value={profile.eMail ? profile.eMail : ''}
                    required
                    onChange={this.handleChange}
                  />
                </div>
                <div className="input-field">
                  <i className="material-icons prefix indigo-text text-accent-4">
                    alternate_email
                  </i>
                  <label htmlFor="emailSeguridad">Email de seguridad *</label>
                  <input
                    type="email"
                    id="emailSeguridad"
                    required
                    onChange={this.handleChange}
                  />
                </div>
                <p>
                  Recuerde que el email de seguridad le servirá para recuperar
                  su sesión en caso de cambio de mail.
                </p>
              </div>
            </div>
            <div className="red-text">
              {authError ? <p>{authError}</p> : null}
            </div>
            <br />
            <br />
            <div className="container">
              <div className="input-field center-align">
                <button className="btn btn-large btn-block indigo accent-4">
                  CONTINUAR
                </button>
              </div>
            </div>
          </form>
          <br />
          <br />
        </div>
      );

    return <div>Loading ...</div>;
  }
}

const mapStateToProps = state => {
  // console.log(state)
  return {
    auth: state.firebase.auth,
    users: state.firestore.data.users,
    authError: state.auth.authError,
    profile: state.firebase.profile
  };
};

const mapDispatchtoProps = dispatch => {
  return {
    completeProfile: newUserProfile => dispatch(completeProfile(newUserProfile))
  };
};

export default compose(
  connect(
    mapStateToProps,
    mapDispatchtoProps
  ),
  firestoreConnect([{ collection: "users" }])
)(AccesForm);
